import { render, staticRenderFns } from "./StatementDetail.vue?vue&type=template&id=432cd297"
import script from "./StatementDetail.vue?vue&type=script&lang=js"
export * from "./StatementDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports